// import
import MailButton from "./MailButton";
// export 
export default MailButton;